import { render, staticRenderFns } from "./TransferWithSort.vue?vue&type=template&id=33d424b1&scoped=true"
import script from "./TransferWithSort.vue?vue&type=script&lang=js"
export * from "./TransferWithSort.vue?vue&type=script&lang=js"
import style0 from "./TransferWithSort.vue?vue&type=style&index=0&id=33d424b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d424b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/overseas_platform_prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d424b1')) {
      api.createRecord('33d424b1', component.options)
    } else {
      api.reload('33d424b1', component.options)
    }
    module.hot.accept("./TransferWithSort.vue?vue&type=template&id=33d424b1&scoped=true", function () {
      api.rerender('33d424b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommonTable/SubmitForm/components/TransferWithSort.vue"
export default component.exports